import { render, staticRenderFns } from "./ScreeningCredits.vue?vue&type=template&id=074493af&scoped=true"
import script from "./ScreeningCredits.vue?vue&type=script&lang=js"
export * from "./ScreeningCredits.vue?vue&type=script&lang=js"
import style0 from "./ScreeningCredits.vue?vue&type=style&index=0&id=074493af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074493af",
  null
  
)

export default component.exports